import React, { useEffect, useRef } from 'react';
import { Check, ChevronDown } from 'lucide-react';

export default function PillSelect({ value, onChange, options, label, testId }) {
  const details = useRef(null);
  useEffect(() => {
    const close = (e) => { if (e.key === 'Escape' || (e.type === 'pointerdown' && !details.current?.contains(e.target))) details.current?.removeAttribute('open'); };
    document.addEventListener('pointerdown', close); document.addEventListener('keydown', close);
    return () => { document.removeEventListener('pointerdown', close); document.removeEventListener('keydown', close); };
  }, []);
  return <details ref={details} className="category-dropdown admin-pill-select" data-testid={testId}>
    <summary aria-label={label}><span>{options.find(option => option.id === value)?.label || label}</span><ChevronDown size={16} /></summary>
    <div className="category-options" aria-label={label}>
      {options.map(option => <button type="button" key={option.id} aria-pressed={value === option.id} onClick={() => { onChange(option.id); details.current.removeAttribute('open'); details.current.querySelector('summary').focus(); }}><span>{option.label}</span>{value === option.id && <Check size={14} />}</button>)}
    </div>
  </details>;
}
